import BaseModal from "../../../SharedComponents/components/Modals/BaseModal";
import BaseButton from "../../../SharedComponents/components/Buttons/BaseButton";
import UserCarDescriptionCard from "../UserCarComponents/UserCarDescriptionCard";
import UserCarImageVisualizer from "../UserCarComponents/UserCarImageVisualizer";
import { getSrcUrlFromFile } from "../../../SharedComponents/utils/helpers/getSrcUrlFromFile";
import BaseActionText from "../../../SharedComponents/components/ActionText/BaseActionText";
import { ButtonVariantEnum } from "../../../SharedComponents/utils/enums/ButtonVariantEnum";
import CarInGarageIconSVG from "../../assets/icons/svg/CarInGarageIconSVG";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";

const AddUserCarInGarageModal = ({
    open,
    setOpen,
    carMake,
    carModel,
    carGeneration,
    carMotor,
    vinNumber,
    selectedImages,
    onConfirm
}) => {

    const urlBlobImageArray = selectedImages.map((file) => getSrcUrlFromFile(file));

    const userCar = {
        vin: vinNumber,
        Make: carMake,
        Model: carModel,
        Motor: carMotor,
        Generation: carGeneration
    };

    return (
        <BaseModal
            open={open}
            setOpen={setOpen}
            externalStyle={styles.externalModalStyle}
        >
            <div>
                <div style={styles.topContent}>
                    <UserCarImageVisualizer
                        carMake={carMake.name}
                        images={urlBlobImageArray}
                    />
                    <UserCarDescriptionCard userCar={userCar} />
                </div>

                <div style={styles.titleContainer}>
                    <p style={styles.title}>
                        Vozilo je spremno za parkiranje ako su svi podaci ispravni!
                    </p>
                </div>

                <div style={styles.actionsContainer}>
                    <BaseActionText
                        onClick={() => setOpen(false)}
                        text='Odustani'
                    />
                    <BaseButton
                        onClick={() => onConfirm?.()}
                        variant={ButtonVariantEnum.BLACK}
                        text={"Parkiraj vozilo u garažu"}
                        IconComponent={CarInGarageIconSVG}
                    />
                </div>
            </div>
        </BaseModal>
    );
};

export default AddUserCarInGarageModal;

const styles = {
    externalModalStyle: {
        paddingBottom: '20px'
    },
    topContent: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 20
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 40
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "24px",
        fontWeight: 600,
        color: "rgba(0, 0, 0, 0.87)"
    },
    actionsContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
        marginTop: 40
    }
};
